import { useState, useEffect } from "react";
import Loading from "./Loading";

const DelayedLoading = ({ delay = 200, ...loadingProps }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(true);
      // Use requestAnimationFrame to ensure the element renders with 0 opacity for transition first
      requestAnimationFrame(() => {
        setFadeIn(true);
      });
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const loadingStyle = {
    opacity: fadeIn ? 1 : 0,
    transition: 'opacity 0.15s ease-in-out'
  };

  return showLoading ? (
    <div style={loadingStyle}>
      <Loading {...loadingProps} />
    </div>
  ) : null;
};

export default DelayedLoading;
